export enum GuestbookLabels {
    day = "Day",
    week = "Week",
    category = "Visit Type"
}
